// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2_qOp","header":"ReportDetails_header__2L9Sf","title":"ReportDetails_title__AJIV3","left":"ReportDetails_left__znG5p"};